export const ORB_FLASH_FEEDBACK_DURATION_MS = 500;
export const ORB_FLASH_OUTLINE_COLOR = 0x39ff14; // neon green for high visibility
export const ORB_FLASH_OUTLINE_THICKNESS = 3;
export const ORB_FLASH_BEEP_EVENT = 'orbFlashBeep';
// Reuse the same tone characteristics as the move-orb sustain cue so the
// temporary selection flash sounds identical to that existing feedback.
export const ORB_MOVE_TONE_FREQUENCY = 432;
export const ORB_MOVE_TONE_GAIN = 0.12;
export const ORB_MOVE_TONE_WAVEFORM = 'sine';
export const ORB_FLASH_BEEP_FREQUENCY = ORB_MOVE_TONE_FREQUENCY;
export const ORB_FLASH_BEEP_GAIN = ORB_MOVE_TONE_GAIN;
export const ORB_FLASH_BEEP_WAVEFORM = ORB_MOVE_TONE_WAVEFORM;
